import { createStyles, Theme } from '@material-ui/core/styles';

const menuPanelStyles = ({ spacing, borders, colors }: Theme) => createStyles({
  root: {
    display: 'block',
    wordBreak: 'break-word',
    padding: `${spacing(3)}px ${spacing(4)}px`,
    borderRadius: borders.radius2,
    height: '100%',
    position: 'relative',
  },
  enabled: {
    background: colors.pageElements.menuPanel.enabled.background,
    '&:hover': {
      cursor: 'pointer',
      background: colors.pageElements.menuPanel.hovered.background,
      '& path': {
        fill: colors.pageElements.menuPanel.hovered.icon,
      },
    },
    '&:hover $icon': {
      visibility: 'visible',
    },
  },
  count: {
    color: colors.pageElements.menuPanel.enabled.counter,
    marginBottom: spacing(1),
  },
  title: {
    marginBottom: spacing(1),
    color: colors.pageElements.menuPanel.enabled.title,
  },
  description: {
    color: colors.pageElements.menuPanel.enabled.description,
  },
  disabled: {
    background: colors.pageElements.menuPanel.disabled.background,
    '& $title, $count, $description': {
      color: colors.pageElements.menuPanel.disabled.title,
    },
  },
  icon: {
    visibility: 'hidden',
    position: 'absolute',
    top: spacing(3),
    right: spacing(4),
  },
  alignCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& $title': {
      marginTop: `-${spacing(1)}px`,
    },
  },
});

export default menuPanelStyles;
